import dayjs from 'dayjs';
import _ from 'lodash';

import { COMMON_REQUEST_DATE_FORMAT } from 'constants/date';

import { PAYMENT_METHOD_OPTIONS, PAYMENT_STATUS_OPTIONS } from '../../Servicing.constants';

const paymentMethodValueMap = _.keyBy(PAYMENT_METHOD_OPTIONS, 'value');
const paymentStatusValueMap = _.keyBy(PAYMENT_STATUS_OPTIONS, 'value');
const paymentStatusNameMap = _.keyBy(PAYMENT_STATUS_OPTIONS, 'name');

export const parseAmount = value => {
  const num = parseFloat(value);

  return Number.isNaN(num) ? 0 : num;
};

export const getInitialFormValues = payment => ({
  paymentDate: payment?.paymentDate ?? dayjs().format(COMMON_REQUEST_DATE_FORMAT),
  effectiveDate: payment?.effectiveDate ?? dayjs().format(COMMON_REQUEST_DATE_FORMAT),
  dueDate: payment?.dueDate ?? null,
  totalAmount: _.isNil(payment?.totalAmount) ? '' : String(payment.totalAmount),
  principalAmount: _.isNil(payment?.principalAmount) ? '' : String(payment.principalAmount),
  interestAmount: _.isNil(payment?.interestAmount) ? '' : String(payment.interestAmount),
  escrowAmount: _.isNil(payment?.escrowAmount) ? '' : String(payment.escrowAmount),
  lateFeeAmount: _.isNil(payment?.lateFeeAmount) ? '' : String(payment.lateFeeAmount),
  otherAmount: _.isNil(payment?.otherAmount) ? '' : String(payment.otherAmount),
  suspenseAmount: _.isNil(payment?.suspenseAmount) ? '' : String(payment.suspenseAmount),
  paymentMethod: payment ? (paymentMethodValueMap[payment.paymentMethod] ?? null) : null,
  paymentStatus: payment
    ? (paymentStatusValueMap[payment.paymentStatus] ?? null)
    : (paymentStatusNameMap.Applied ?? null),
  referenceNumber: payment?.referenceNumber ?? '',
  notes: payment?.notes ?? '',
});
